import { render, staticRenderFns } from "./AddressArgument.vue?vue&type=template&id=649874a0&scoped=true&"
import script from "./AddressArgument.vue?vue&type=script&lang=js&"
export * from "./AddressArgument.vue?vue&type=script&lang=js&"
import style0 from "./AddressArgument.vue?vue&type=style&index=0&id=649874a0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "649874a0",
  null
  
)

export default component.exports